// `state.from` (session-expired-modal.tsx / RedirectToLoginPreservingPath /
// routes/index.tsx) is attacker-influenceable — it's built from the current
// URL's own path+search, which an attacker fully controls via a crafted
// link. Login pages read it back and `navigate()` there post-login (Pollen
// review, round 4, Low item: "not exploitable today" because nothing
// currently writes an off-origin value in, but a future change easily could
// without this guard). Only a same-origin, path-absolute value is safe to
// redirect to: reject anything that isn't exactly one leading `/` (a `//` or
// `/\` prefix is browser-parsed as protocol-relative and can leave the app).
export function safeRedirectPath(from: string | undefined | null): string | undefined {
    if (!from || !from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) {
        return undefined;
    }
    return from;
}
